export const environment = {
  production: true,
  bsc: {
    chainId: "0x38", //hexadecimal for metamask
    chainIdInt: 56,
    chainName: "BSC Mainnet",
    purchaseToken: "BNB",
    presaleAddress: "0xe99d93b7432c3f15f893058f24a410cac087ecc3",
    usdTAddress: "0x55d398326f99059ff775485246999027b3197955",
    rpcURL: "https://wiser-still-leaf.bsc.quiknode.pro/6dcf923f5afe26cdf9c6fc1517335d9ed6761f36/",
    backupRPC: "https://wiser-still-leaf.bsc.quiknode.pro/6dcf923f5afe26cdf9c6fc1517335d9ed6761f36/",
    blockExplorerURL: "https://bscscan.com/tx/",
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [{
        chainId: "0x38",
        chainName: "BSC Mainnet",
        nativeCurrency: {
          name: "BNB",
          symbol: "BNB",
          decimals: 18,
        },
        rpcUrls: ["https://bsc-dataseed2.ninicoin.io/"],
        blockExplorerUrls: ["https://bscscan.com/"],
      }]
    }
  },
  eth: {
    chainId: "0x1", //hexadecimal for metamask
    chainIdInt: 1,
    chainName: "Ethereum Mainnet",
    purchaseToken: "ETH",
    presaleAddress: "0xe99d93b7432c3f15f893058f24a410cac087ecc3",
    usdTAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    rpcURL: "https://nameless-practical-snowflake.quiknode.pro/1b2c215cfb4bb1e4e3eb7eae2943f2aa6e1e6916/",
    backupRPC: "https://eth-mainnet.g.alchemy.com/v2/Q64j-dUcmTvkonS0BV0IS_JbT0yM6Ilm",
    blockExplorerURL: "https://etherscan.io/tx/",
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [{
        chainId: "0x1",
        chainName: "Ethereum Mainnet",
        nativeCurrency: {
          name: "ETH",
          symbol: "ETH",
          decimals: 18,
        },
        rpcUrls: ["https://rpc.ankr.com/eth"],
        blockExplorerUrls: ["https://etherscan.io/"],
      }]
    }
  },
  tokenAddress: "0x24f2f371d74b25da7597adeae55895fe6b5c2fde",
  tokenName: "BWAT",
  apiURL: "https://3ip2lxclvsql6vq2bzdsf3nswa0jowlj.lambda-url.eu-west-2.on.aws/",
  iidDashFx: 820,
  urlDashFx: 'https://cbjqg85yae.execute-api.eu-west-2.amazonaws.com/production/dashFxPresaleMiddlewareApi',
  wertOrigin: 'https://widget.wert.io',
  partnerId: '01GW9X62JFY1D65ZF6TBHPXZ5P',
  wertUrl: "https://tqkrq62exxennvaffn4dh7jsi40dhykr.lambda-url.eu-west-2.on.aws/",
  newsLetterListId: '35',
  newsLetterURL: "https://hapnrbbvbi2y6amec34yhokl2a0hvbep.lambda-url.eu-west-2.on.aws/",
  web3clientId:   "BN49NgIkWhlhw1Y6Z0SJL-Y7hQYXTtl4550pYv0AZN_I3uicPqn66qNWtTY8MJYq-hcjCAJdUEmQpqxz36YFmIc",
  googleClientId: "494120978498-fmidb2bbdko960i4klqjpdafbr8rm3r6.apps.googleusercontent.com",
  torusWalletId:  "BIbI9LiAZh2CQtAeHN8Nk6sUTZSg4TGN0GC9VPVibOG81rRERORIdhWpAoo7T7SgcBMboPPVnuyOy_8wjk50Q_8",
  dashFxReferral: "https://l1kzl4fgj2.execute-api.eu-west-2.amazonaws.com/default/dashFXReferral",
  partnerListURL: "https://4obdfb4aqn25oq5zl2pdzhvyze0hgxoj.lambda-url.eu-west-2.on.aws/",
  partnerListId: "41",
  bestWalletBackendURL: "https://dev-api.bestwallet.com",
};

/*export const environment = {
  production: false,
  bsc: {
    chainId: "0x61", //hexadecimal for metamask
    chainIdInt: 97,
    chainName: "BSC Mainnet",
    purchaseToken: "BNB",
    presaleAddress: "0x6634Ed48826Fd0623A1C0C26c6d0B5B216532488",
    usdTAddress: "0xadfc9b54fb7a1677176a7529f03b91081c91355c",
    rpcURL: "https://wiser-still-leaf.bsc.quiknode.pro/6dcf923f5afe26cdf9c6fc1517335d9ed6761f36/",
    backupRPC: "https://wiser-still-leaf.bsc.quiknode.pro/6dcf923f5afe26cdf9c6fc1517335d9ed6761f36/",
    blockExplorerURL: "https://bscscan.com/tx/",
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [{
        chainId: "0x61",
        chainName: "BSC Mainnet",
        nativeCurrency: {
          name: "BNB",
          symbol: "BNB",
          decimals: 18,
        },
        rpcUrls: ["https://bsc-dataseed2.ninicoin.io/"],
        blockExplorerUrls: ["https://bscscan.com/"],
      }]
    }
  },
  eth: {
    chainId: "0x5", //hexadecimal for metamask
    chainIdInt: 5,
    chainName: "Ethereum Mainnet",
    purchaseToken: "ETH",
    presaleAddress: "0x005f18575fd76361a6c2f90168222fea8f022987",
    usdTAddress: "0x43cD6f7be156a335875853113B2943C7383e3781",
    rpcURL: "https://nameless-practical-snowflake.quiknode.pro/1b2c215cfb4bb1e4e3eb7eae2943f2aa6e1e6916/",
    backupRPC: "https://eth-mainnet.g.alchemy.com/v2/Q64j-dUcmTvkonS0BV0IS_JbT0yM6Ilm",
    blockExplorerURL: "https://etherscan.io/tx/",
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [{
        chainId: "0x5",
        chainName: "Ethereum Mainnet",
        nativeCurrency: {
          name: "ETH",
          symbol: "ETH",
          decimals: 18,
        },
        rpcUrls: ["https://rpc.ankr.com/eth"],
        blockExplorerUrls: ["https://etherscan.io/"],
      }]
    }
  },
  tokenAddress: "0x24f2f371d74b25da7597adeae55895fe6b5c2fde",
  tokenName: "BWAT",
  apiURL: "https://3ip2lxclvsql6vq2bzdsf3nswa0jowlj.lambda-url.eu-west-2.on.aws/",
  iidDashFx: 820,
  urlDashFx: 'https://cbjqg85yae.execute-api.eu-west-2.amazonaws.com/production/dashFxPresaleMiddlewareApi',
  wertOrigin: 'https://sandbox.wert.io',
  partnerId: '01GNW5RN7BP3A60GDHM5V0CHHV',
  wertUrl: "https://bj6y5wq34qjqmvce36kyszwvue0ejxcb.lambda-url.eu-west-2.on.aws/",
  newsLetterListId: '35',
  newsLetterURL:  "https://xenfkwhv4g3mwadjavtom3snm40hefnq.lambda-url.eu-west-2.on.aws/",
  web3clientId:   "BFYCewyjqIXHrYewkABWF5bxkhE-B1zxzOM2Q5ULBhXbyQ_iKHvy6bBDGxGO76yR5Ze4ZY9_MyU14bt1fQoCdMs",
  googleClientId: "494120978498-fmidb2bbdko960i4klqjpdafbr8rm3r6.apps.googleusercontent.com",
  torusWalletId:  "BIbI9LiAZh2CQtAeHN8Nk6sUTZSg4TGN0GC9VPVibOG81rRERORIdhWpAoo7T7SgcBMboPPVnuyOy_8wjk50Q_8",
  dashFxReferral: "https://l1kzl4fgj2.execute-api.eu-west-2.amazonaws.com/default/dashFXReferral"
};
*/
